const brand = {
    getlist: 'brand/getlist',
    add: 'brand/add',
    update: 'brand/update',
    remove: 'brand/remove',
    get: 'brand/get',
    getall: 'brand/getall',
    clearcache: 'brand/clear-cache',
}
export default brand
